/**
 * TutorApplicationProfileScreen — l'étape 1 de la candidature, le profil (route
 * `application-personal-infos`, l'ancien `ApplicationPersonalInfos`) : onze questions, une à la
 * fois, puis `PUT /api/v1/personal-infos` et la fin d'étape du champion de l'accueil.
 */
import React from "react"

import { Snackbar } from "../../../../../../design-system"
import { TutorApplicationQuestionPage, TutorApplicationStepDonePage } from "../../../../../../design-system/tutor"
import { useTutorApplicationProfileState } from "./useTutorApplicationProfileState"

export function TutorApplicationProfileScreen() {
    const form = useTutorApplicationProfileState()

    if (form.done) return <TutorApplicationStepDonePage {...form.stepDone} testID="tutor-application-step-done" />
    return (
        <>
            {form.page != null && <TutorApplicationQuestionPage {...form.page} testID="tutor-application-profile" />}
            <Snackbar {...form.restoredNotice} />
        </>
    )
}
